import { DefaultOptions, QueryClient } from 'react-query';  //React 애플리케이션에서 상태와 캐싱을 관리하는 라이브러리

const queryConfig: DefaultOptions = {
	queries: {
			// useErrorBoundary: true는 쿼리에서 에러가 발생했을 때 에러 경계를 사용하도록 설정합니다.
			useErrorBoundary: true,

			// keepPreviousData: true는 이전 데이터를 유지하도록 설정하여 새로운 데이터를 가져오는 동안에도 이전 데이터를 사용할 수 있게 합니다.
			keepPreviousData: true,

			// retry: false는 쿼리 재시도를 비활성화하므로, 데이터를 다시 가져오지 않고 에러가 발생하면 중단됩니다.
			retry: false,
	},
};

// QueryClient를 생성하면서 위에서 정의한 기본 쿼리 옵션을 적용합니다.
export const queryClient = new QueryClient({ defaultOptions: queryConfig });
